<template>
  <div class="pb-9">

    <div class="text-center mt-16 mb-16" dir="auto">
      <AboutTitle :title="$t('features-ACC')" color="success" page-route="/sub/light-blocks"/>
<!--      <div  class="text-right w-80 mx-auto mt-16 mb-16" dir="auto">-->
<!--        <h2  class=" font-weight-bold" >{{$t('features-ACC')}}</h2>-->
<!--      </div>-->
    </div>
    <v-row>
    <v-col cols="12" xl="3" md="3" lg="3" v-for="(item,i) in block_features" :key="i">
      <v-card color="success"  height="180" class="mx-4 mb-5  card-hover pointer" >
        <img width="70" class="py-3" v-if="item.photo_file" :src="item.photo_file" alt="">
        <v-icon v-else color="secondary" size="80" class="py-3">{{ item.icon }}</v-icon>
        <h4 class="font-weight-bold card-title py-6">{{ item.title }}</h4>
<!--        <p class="px-5 py-3 card-detail">{{ item.details }}</p>-->
      </v-card>
    </v-col>
    </v-row>
  </div>
</template>
<script>
import {mapState} from "vuex";
import AboutTitle from "../../glass/pages/About/Components/AboutTitle";

export default {
  name: 'lightBlocksFeatures',
  components: {AboutTitle},
  data() {
    return {
      features: [
        {
          title: 'عایق حرارت',
          details: 'بلوک سبک AAC، دارای مقاومت بیش از ۲۰ مگاپاسکال است. ',
          icon: 'mdi-fire'
        },
        {
          title: 'عایق صوت',
          details: 'بلوک هبلکس، به علت ساختار سلولی و حبابی شکل بودن، قابل اشتعال نبوده ',
          icon: 'mdi-account-tie-voice'
        },
        {
          title: 'سبک',
          details: 'ساختار مولکولی و نحوه پخش حباب‌های هوا در بلوک سبک اتوکلاوشده، آن را به عنوان یکی از مصالح خوب در رابطه با عایق صوتی تبدیل کرده است.',
          icon: 'mdi-align-vertical-bottom'
        },
        {
          title: 'سرعت اجرای بالا',
          details: 'بلوک سبک AAC، دارای مقاومت بیش از ۲۰ مگاپاسکال است. ',
          icon: 'mdi-all-inclusive'
        },
        {
          title: 'مقاوم در برابر حریق',
          details: 'بلوک هبلکس، به علت ساختار سلولی و حبابی شکل بودن، قابل اشتعال نبوده ',
          icon: 'mdi-fireplace'
        },
        {
          title: 'مقاوم در برابر زلزله',
          details: 'ساختار مولکولی و نحوه پخش حباب‌های هوا در بلوک سبک اتوکلاوشده، آن را به عنوان یکی از مصالح خوب در رابطه با عایق صوتی تبدیل کرده است.',
          icon: 'mdi-castle'
        },
        {
          title: 'دوستدار محیط زیست',
          details: 'بلوک هبلکس، به علت ساختار سلولی و حبابی شکل بودن، قابل اشتعال نبوده ',
          icon: 'mdi-pine-tree'
        },
        {
          title: 'عدم نفوذ جانواران موذی',
          details: 'ساختار مولکولی و نحوه پخش حباب‌های هوا در بلوک سبک اتوکلاوشده، آن را به عنوان یکی از مصالح خوب در رابطه با عایق صوتی تبدیل کرده است.',
          icon: null,
          img: require('@/assets/icons/noun-no-bugs.svg'),
        },
      ]
    }
  },
  computed:{
    ...mapState({
      block_features:state => state.lightBlocksManagement.block_features,
    })
  },
  created(){
    this.$store.dispatch('lightBlocksManagement/getFeatures');
  }
}
</script>
<style scoped>
/*.card-hover:hover > i {*/
/*  color: #7BAD32 !important;*/
/*}*/
.card-hover{
  text-align: center;
}
.card-hover:hover{
  padding-right: 15px;
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1), visibility 0s;
}
.card-hover:hover>i{
  font-size: 50px !important;
}
.card-hover:hover>img{
  width: 50px;
  transition: width 0.5s;
}
.card-detail {
  opacity: 0;
}
.card-hover:hover > .card-detail {
  opacity: 1;
  transition: opacity .7s;
}
</style>